export default import.meta.ROLLUP_FILE_URL_z8IqaDpT53LmDJcH$tHz3g;